import { isNumber } from 'lodash-es';
import type { CSSProperties, ForwardedRef, InputHTMLAttributes, ReactNode } from 'react';

export const InputVariants = {
  Default: 'Default',
  Primary: 'Primary',
  Positive: 'Positive',
  Negative: 'Negative',
  Warning: 'Warning',
} as const;
export type InputVariants = (typeof InputVariants)[keyof typeof InputVariants];

export const InputStates = {
  Default: '',
  Hover: 'Hover',
  Focus: 'Focus',
} as const;
export type InputStates = (typeof InputStates)[keyof typeof InputStates];

export const FormControlSizes = {
  /** Mostly the same as Tiny (same font size, line height) except with less vertical padding. */
  Xxs: 0.75,
  Tiny: 1,
  Small: 1.5,
  Default: 2,
  Large: 2.5,
} as const;
export type FormControlSizes = (typeof FormControlSizes)[keyof typeof FormControlSizes];

export const FORM_CONTROL_SIZES = Object.values(FormControlSizes).filter(isNumber);

export type ValueTypes = 'text' | 'number';
export type FormControlProps<T> = Omit<InputHTMLAttributes<T>, 'prefix'> & {
  size?: FormControlSizes;
  width?: CSSProperties['width'];
  inline?: boolean;
  /** Custom prefix before the text input */
  prefix?: ReactNode;
  /** The suffix of the input, e.g. a currency symbol */
  suffix?: ReactNode;
  type?: ValueTypes;
  touched?: boolean;
  invalid?: boolean;
  /** When true (and not invalid), shows a warning icon beside the input. */
  warning?: boolean;
  wrapperRef?: ForwardedRef<HTMLLabelElement>;
  controlStyle?: any;
  clearable?: boolean;
  variant?: InputVariants;
  /** Removes border and border-radius, useful for embedded inputs like search in dropdowns */
  embedded?: boolean;
};
